// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6a8f9fb","337":"22e79343","422":"da8c4d8a","667":"8b67a2bf"}[chunkId] + ".chunk.js";
};